import { FC } from 'react';

import { RefetchAuto } from '@features/refetch-auto';
import RefreshBtn from '@features/refresh-btn';
import { TableControlMenu } from '@features/table-control-menu';
import { MenuItem } from '@mui/material';

interface IProps {
  refetch: () => void;
  refreshInterval?: string;
  setRefreshInterval?: (interval: string) => void;
}

export const TradersToolbar: FC<IProps> = ({ refetch, refreshInterval, setRefreshInterval }) => {
  return (
    <TableControlMenu>
      <MenuItem>
        <RefreshBtn refetch={refetch} />
      </MenuItem>
      <MenuItem data-menu-type='dropdown'>
        <RefetchAuto refreshInterval={refreshInterval} onChangeInterval={setRefreshInterval} />
      </MenuItem>
    </TableControlMenu>
  );
};
